export default "__VITE_ASSET__DrX7u1BM__"